import { defineArticleAssets } from "@th-m/blogs/mdx";

export default defineArticleAssets({
  "consequence-returns-to-context-motif": { kind: "figure", label: "Consequence Returns to Context Motif", tags: ["article-figure", "ai-factory-series", "mdx-component"] },
  "light-cone-scorecard": { kind: "figure", label: "Cognitive Reach Profile", tags: ["article-figure", "mdx-component"] },
});
